export async function fetchPdfAsBase64(pdfUrl) {
  const response = await fetch(pdfUrl);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // reader.result -> data:application/pdf;base64,...
      const base64data = reader.result.split(',')[1]; // bez nagłówka
      resolve(base64data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}